import { RSAA } from 'redux-api-middleware'
import {
  getApiPath,
  makeApiTypes,
  makeQueryParams,
} from 'sidecar-utility-library'

export const types = {
  ...makeApiTypes('FETCH_REVIEW', 'trustPilot'),
}

export const fetchTrustPilot = ({ email, firstName, lastName, uuid }) => ({
  [RSAA]: {
    endpoint: getApiPath(
      `acct`,
      `reviewlink${makeQueryParams({
        email,
        firstname: firstName,
        lastname: lastName,
        refid: uuid,
      })}`,
    ),
    method: 'GET',
    types: [
      types.FETCH_REVIEW_REQUEST,
      types.FETCH_REVIEW_SUCCESS,
      types.FETCH_REVIEW_ERROR,
    ],
  },
})

const initialState = {
  reviewlink: {
    busy: false,
    error: null,
    entity: '',
  },
}

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.FETCH_REVIEW_REQUEST: {
      return {
        ...state,
        reviewlink: {
          ...state.reviewlink,
          busy: true,
          error: null,
        },
      }
    }

    case types.FETCH_REVIEW_SUCCESS: {
      return {
        ...state,
        reviewlink: {
          busy: false,
          error: null,
          entity: payload.url,
        },
      }
    }

    case types.FETCH_REVIEW_ERROR: {
      return {
        ...state,
        reviewlink: {
          ...state.reviewlink,
          busy: false,
          error: payload?.response?.message,
        },
      }
    }

    default:
      return state
  }
}
